import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'X-Client-Type': 'web', // Custom header to specify client type
  },
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log(error, 'error in axios');
    if (
      error.response &&
      error.response.status === 401 &&
      !window.location.pathname.includes('/auth/sign-in')
    ) {
      // Clear user session data
      localStorage.clear();
      sessionStorage.clear();
      // Clear token cookie
      document.cookie =
        'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

      // Redirect to login after 100ms
      setTimeout(() => {
        window.location.href = '/auth/sign-in';
      }, 100);
    }
    return Promise.reject(error);
  }
);

export default api;
